import type { IAuthor } from "types";
import { BASE_CLASS } from "../PostCard";
import css from "../PostCard.module.css";

interface PostCardAuthorProps {
  author: IAuthor;
}

export const PostCardAuthor = ({ author }: PostCardAuthorProps) => {
  const { name, description } = author;
  return (
    <div className={css[`${BASE_CLASS}-author`]}>
      <div className={css["text"]}>
        <strong>{name}</strong>
        {description && <span>{author.description}</span>}
      </div>
    </div>
  );
};
